import React from "react";

import { Accordion } from "@/components/Atoms";

const FAQs = [
  {
    question: "How is Shyft pass different from a Gym membership?",
    answer:
      "Gyms mostly focus on fitness and on cardio + weight training and are often not able to bring a lot of variety and upcoming workouts to you. With Shyft Pass, we try to bring you what is not already around you, what is upcoming or a bit different, something to add variety to your wellness routine, and hopefully make the variety a part of your wellness routine!",
  },
  {
    question: "How do you decide which workouts to add?",
    answer:
      "As Shyft, we cater to wellness more than fitness, and we cater to a certain age-group more than others. So we bring workouts which we think are fit for this purpose. We also realize the fitness levels of everyone are not the same, so our workouts need to allow people at different levels of proficiency to get benefitted from our schedule.",
  },
  {
    question: "How do you decide which venues to add?",
    answer:
      "We look at three important factors - quality of the venue and its upkeep, location of the venue and it being centrally located to the city we are catering to, and availability of parking!",
  },
  {
    question: "Will you keep adding venues and workout styles?",
    answer:
      "Absolutely. Over time, we will increase the options you get every weekend with new formats and venues. We will also not make the list very long that you find it tough to decide or have FOMO, but we want you to have enough choice.",
  },
  {
    question: "What are the mixers and how will I get invited?",
    answer:
      "You will have access to all community mixers we do and they will show up on your schedule. You will need to rsvp in time so that you get a spot. These will happen in small groups in your vicinity. We will also invite industry experts, founders of wellness brands, to interact with our members and foster learning.",
  },
  {
    question: "What kind of wellness products will I get?",
    answer:
      "The wellness industry is ever evolving, and you keep seeing new trends, new superfoods, new supplements, new snacks, new personal care products. We work with young brands who are doing something new and which has not yet reached scale. You will get access to these products!",
  },
  {
    question:
      "When you open in other cities, will I have access to Shyft Pass in those cities too?",
    answer: "Absolutely!",
  },
  {
    question: "Is the membership refundable?",
    answer:
      "No, your membership is non-refundable. We work on limited participation in all our workouts and events, so the planning doesn't allow us to refund.",
  },
];

const FAQSection = () => (
  <div id="shyft-pass-faq" className="container faq-section">
    <h2 className="faq-title">Frequently asked questions</h2>
    <div className="faq-list-container">
      {FAQs?.map(({ question, answer }, index) => (
        <div key={index} className="accordion-container">
          <Accordion title={question} content={answer} />
        </div>
      ))}
    </div>
  </div>
);

export default FAQSection;
